import { render, staticRenderFns } from "./segundoCupon.vue?vue&type=template&id=9feb4dd6&scoped=true&"
import script from "./segundoCupon.vue?vue&type=script&lang=js&"
export * from "./segundoCupon.vue?vue&type=script&lang=js&"
import style0 from "./segundoCupon.vue?vue&type=style&index=0&id=9feb4dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9feb4dd6",
  null
  
)

export default component.exports